import GlobalStyles from '@mui/material/GlobalStyles';
import {StyledEngineProvider} from '@mui/material/styles';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {scan} from 'react-scan'; // must be imported before React and React DOM
import {startupProfiler} from './common/utils/startupProfiler';
import {configuration} from './config';
import {getOrInitializeFirebaseApp} from './firebase/FirebaseApp';
import {App} from './main/App';
import reportWebVitals from './reportWebVitals';
import {logger} from '#common/logging/logger';

// See https://fontsource.org/fonts and https://fonts.google.com for other font options
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Enable React Scan in development mode:
scan({
  enabled: configuration.environment === 'development',
});

logger.setLevel(configuration.logLevel);
startupProfiler.mark('Root Bundle Evaluated');

// Pre-warm Firebase App and Auth credential lookup in background
getOrInitializeFirebaseApp();

// Automatically reload app when Service Worker updates to a new build
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

const root = createRoot(document.getElementById('root') as HTMLElement);
startupProfiler.mark('Mounting React DOM');
root.render(
  <React.StrictMode>
    <StyledEngineProvider enableCssLayer>
      <GlobalStyles styles="@layer theme,base,mui,components,utilities;" />
      <App />
    </StyledEngineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
